import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between mt-4" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "flex justify-between mt-4" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "icon-spin"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "h-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selector = _resolveComponent("selector")!
  const _component_Selector = _resolveComponent("Selector")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModalAlert = _resolveComponent("ModalAlert")!
  const _component_AddButton = _resolveComponent("AddButton")!
  const _component_TableComponent = _resolveComponent("TableComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Modal, {
      title: "Agregar extintor",
      visible: _ctx.showModalAdd,
      "onUpdate:visible": _cache[4] || (_cache[4] = (e) => _ctx.showModalAdd = e)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_selector, {
          items: _ctx.formattedBlockList,
          selectedItem: Number(_ctx.blockId),
          placeHolder: 'Seleccione un bloque',
          label: 'Bloque',
          onUpdate: _ctx.onSelect
        }, null, 8, ["items", "selectedItem", "onUpdate"]),
        _createVNode(_component_Selector, {
          items: _ctx.FireExtinguisherType,
          selectedItem: Number(_ctx.typeBuilding),
          placeHolder: 'Seleccione tipo de extintor',
          label: 'Tipo de extintor',
          onUpdate: _ctx.onUpdateModel
        }, null, 8, ["items", "selectedItem", "onUpdate"]),
        _createVNode(_component_TextField, {
          label: "Cantidad",
          model: _ctx.quantity,
          "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.quantity) = $event)),
          type: "number",
          name: "cantidad"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Mantenimiento",
          model: _ctx.maintenance,
          "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.maintenance) = $event)),
          type: "date",
          name: "Mantenimento"
        }, null, 8, ["model"])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "px-4 py-2 mr-2 rounded-md bg-gray-300 hover:bg-gray-400 focus:bg-gray-400",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModalAdd = false))
          }, " Cancelar "),
          _createElementVNode("button", {
            class: _normalizeClass(["px-4 py-2 rounded-md bg-primary text-white hover:bg-green-600 focus:bg-green-600", {
              'opacity-50 cursor-not-allowed disabled:pointer-events-none': !_ctx.isFieldsFilled,
            }]),
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveExtinguisher && _ctx.saveExtinguisher(...args))),
            disabled: !_ctx.isFieldsFilled
          }, " Agregar ", 10, _hoisted_2)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_ModalAlert, {
      visible: _ctx.showModalAlert,
      option: true
    }, null, 8, ["visible"]),
    _createVNode(_component_Modal, {
      title: "Editar extintor",
      visible: _ctx.showModalEdit,
      "onUpdate:visible": _cache[9] || (_cache[9] = (e) => _ctx.showModalEdit = e)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_selector, {
          items: _ctx.formattedBlockList,
          selectedItem: Number(_ctx.blockId),
          placeHolder: 'Seleccione un bloque',
          label: 'Bloque',
          onUpdate: _ctx.onSelect
        }, null, 8, ["items", "selectedItem", "onUpdate"]),
        _createVNode(_component_Selector, {
          items: _ctx.FireExtinguisherType,
          selectedItem: Number(_ctx.typeBuilding),
          placeHolder: 'Seleccione tipo de extintor',
          label: 'Tipo de extintor',
          onUpdate: _ctx.onUpdateModel
        }, null, 8, ["items", "selectedItem", "onUpdate"]),
        _createVNode(_component_TextField, {
          label: "Cantidad",
          model: _ctx.quantity,
          "onUpdate:model": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.quantity) = $event)),
          type: "number",
          name: "cantidad"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Mantenimiento",
          model: _ctx.maintenance,
          "onUpdate:model": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.maintenance) = $event)),
          type: "date",
          name: "Mantenimento"
        }, null, 8, ["model"])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "px-4 py-2 mr-2 rounded-md bg-gray-300 hover:bg-gray-400 focus:bg-gray-400",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showModalEdit = false))
          }, " Cancelar "),
          _createElementVNode("button", {
            class: _normalizeClass(["px-4 py-2 rounded-md bg-primary text-white hover:bg-green-600 focus:bg-green-600", {
              'opacity-50 cursor-not-allowed disabled:pointer-events-none': !_ctx.isFieldsFilled,
            }]),
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.saveEditItem && _ctx.saveEditItem(...args))),
            disabled: !_ctx.isFieldsFilled
          }, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Agregar"))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, _hoisted_8))
          ], 10, _hoisted_4)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    (_ctx.formattedData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_TableComponent, {
            title: 'Extintores',
            items: _ctx.formattedData,
            columns: _ctx.columns,
            buttons: _ctx.buttons,
            showButtons: _ctx.showButtons,
            searchTableData: _ctx.searchTableData
          }, {
            "extra-header": _withCtx(() => [
              _createVNode(_component_AddButton, {
                onClick: _ctx.addItem,
                class: "self-end w-full flex justify-end mr-4"
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["items", "columns", "buttons", "showButtons", "searchTableData"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showEditAlert)
      ? (_openBlock(), _createBlock(_component_ModalAlert, {
          key: 1,
          option: true
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalAlert, {
      title: 'Eliminar estinguidor',
      message: '¿Esta seguro de eliminar este estinguidor?',
      visible: _ctx.showAlertModal,
      onAccept: _ctx.handleAccept,
      onCancelAlert: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showAlertModal = false))
    }, null, 8, ["visible", "onAccept"])
  ]))
}